<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row p-0 m-0">
      <div class="col-12 p-0 m-0">
        <viewmaker-tabs ref="viewmakertabs" v-bind:rowclick="rowclick" v-bind:togglestatus="togglestatus"  v-bind:multiplerowclick="multiplerowclick" @tabClick="tabClick"></viewmaker-tabs>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'viewmaker-container',
    components: {
    },
    props: {

      rowclick: {
        required: false,
        type: String,
        default: ''
      },
      multiplerowclick: {
        required: false,
        type: String,
        default: ''
      },
      togglestatus: {
        required: false,
        type: String,
        default: ''
      },
      
    },
    methods: {
      tabClick(tab) {
        //alert("clicked on tab, now setting tab")
        //this.$refs.tablesection.setTab(tab);
      },
      clearSelected() {
        this.$refs.viewmakertabs.clearSelected();
      },
    },
    created() {

    },
    mounted() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/viewmaker/viewmaker-container.vue